/* 🤖 this file was generated by script */
export const wiconCopyRow = {
  name: 'copy_row',
  data: `<svg viewBox="0 0 20 20"><rect width="13" height="5" x="3.5" y="3.5" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" rx="1"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M5.13 11.28H4.5a1 1 0 00-1 1v.44m0 2.46v.1a1 1 0 001 1h.63m3.3-5h3.19m-3.2 5h3.2m3.24 0h.64a1 1 0 001-1v-.1m-1.64-3.9h.64a1 1 0 011 1v.44"/></svg>`,
};
